export class CompanyPhotoModel {
  companySurrKey: number;
  companyName: string;
}

export  class CompanyPhotoResponseModel {
  count: number;
  companyList: Array<CompanyPhotoModel>;
}
